import React from 'react';

export default function TrendArrow({ direction }) {
  if (direction === 'up') return <span className="tv3-trend tv3-trend-up" aria-label="Trending up">↑</span>;
  if (direction === 'down') return <span className="tv3-trend tv3-trend-down" aria-label="Trending down">↓</span>;
  if (direction === 'stable') return <span className="tv3-trend tv3-trend-stable" aria-label="Steady">→</span>;
  return null;
}

export function computeTrend(history) {
  const vals = (history || [])
    .slice()
    .reverse()
    .filter(h => h && h.confidence != null);
  if (vals.length < 2) return null;
  const first = vals[0].confidence;
  const last = vals[vals.length - 1].confidence;
  const delta = last - first;
  if (delta > 0.02) return 'up';
  if (delta < -0.02) return 'down';
  return 'stable';
}
